import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "text-end" }
const _hoisted_2 = { class: "d-flex flex-column justify-content-center h-60px" }
const _hoisted_3 = { class: "mb-1" }
const _hoisted_4 = { class: "fs-7 text-gray-400" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, null, -1)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { colspan: "9" }
const _hoisted_10 = { class: "d-flex flex-column justify-content-center align-items-center h-60px" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_common_product = _resolveComponent("common-product")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.items, (item, index) => {
      return (_openBlock(), _createElementBlock("tr", {
        class: "subtable_template inbound text-start",
        key: index
      }, [
        _createVNode(_component_common_product, {
          gallery: item.gallery,
          brand_id: item.__show.brand_id,
          source_link: '',
          name: item.name,
          name_en: item.name_en,
          brand_article_no: item.brand_article_no,
          product_identifier_id: '0',
          color: item.original_color,
          size: item.__show.size,
          productCol: 3,
          skuCol: 3
        }, null, 8, ["gallery", "brand_id", "name", "name_en", "brand_article_no", "color", "size"]),
        _createElementVNode("td", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.t("order.qty")), 1),
            _createElementVNode("span", _hoisted_4, _toDisplayString(item.quantity), 1)
          ])
        ]),
        _hoisted_5,
        _hoisted_6,
        _hoisted_7
      ]))
    }), 128)),
    (_ctx.formData.items.length == 0)
      ? _withDirectives((_openBlock(), _createElementBlock("tr", _hoisted_8, [
          _createElementVNode("td", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.isRequest ? "No data found" : ""), 1)
          ])
        ])), [
          [_directive_loading, _ctx.loading]
        ])
      : _createCommentVNode("", true)
  ], 64))
}